<template>
  <div class="testimonials-section">
    <div class="container">
      <h2 class="section-title">What Our Customers Say</h2>
      <div class="testimonials-grid">
        <div
          v-for="testimonial in testimonials"
          :key="testimonial.id"
          class="testimonial-card"
        >
          <div class="quote-icon">“</div>
          <p class="testimonial-text">{{ testimonial.text }}</p>
          <div class="author-info">
            <img
              :src="testimonial.photo"
              :alt="testimonial.name"
              class="avatar-photo"
            />
            <div class="author-details">
              <div class="author-name">{{ testimonial.name }}</div>
              <div class="author-title">{{ testimonial.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import photo1 from '@/assets/images/reviews/1.jpg'
import photo2 from '@/assets/images/reviews/2.jpg'
import photo3 from '@/assets/images/reviews/3.jpg'

export default {
  name: 'reviews',

  data() {
    return {
      testimonials: [
        {
          id: 1,
          name: 'Michael',
          title: 'Purchasing Manager',
          photo: photo1,
          text: 'The quality of the CNC machined parts exceeded our expectations. The precision and surface finish are excellent, and the delivery was on time. Very professional team to work with!'
        },
        {
          id: 2,
          name: 'Emily',
          title: 'Engineering Director',
          photo: photo2,
          text: "We've been working with them for over a year and are always impressed with the consistent quality and quick response. They are a reliable partner for our CNC machining needs."
        },
        {
          id: 3,
          name: 'James',
          title: 'Product Manager',
          photo: photo3,
          text: 'From prototype to mass production, their CNC machining services have been top notch. Great communication, fair pricing, and high-quality parts every time.'
        }
      ]
    }
  }
}
</script>

<style scoped>
/* 基础重置与字体 */
.testimonials-section {
  padding: 4rem 1.5rem;
  background-color: #f9fafb;
  font-family: system-ui, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
  display: block;
  clear: both;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 标题样式 */
.section-title {
  text-align: center;
  font-size: 2.2rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: #1e293b;
  margin-bottom: 3rem;
  position: relative;
  padding-bottom: 0.75rem;
  display: block;
  width: 100%;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, #5D9B9B, #E8A87C);
  border-radius: 2px;
}

/* 网格布局 —— 响应式卡片 */
.testimonials-grid {
  display: grid;
  /* 默认单列，适用于 <1024px 的所有屏幕 */
  grid-template-columns: repeat(1, 1fr);
  gap: 2rem;
  width: 100%;
}

/* ⭐ 删除了 min-width: 768px 的双列逻辑，直接在 >=1024px 时切换为三列 */
@media (min-width: 1024px) {
  .testimonials-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* 卡片设计 */
.testimonial-card {
  background: white;
  border-radius: 1.5rem;
  padding: 1.8rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.02);
  transition: all 0.25s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.03);
}

/* 引号装饰 */
.quote-icon {
  font-size: 3.2rem;
  line-height: 1;
  font-family: Georgia, serif;
  color: #cbd5e1;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

/* 评价文本 */
.testimonial-text {
  color: #334155;
  line-height: 1.6;
  font-size: 1rem;
  margin: 0 0 1.8rem 0;
  flex-grow: 1;
  font-weight: 400;
  letter-spacing: 0.01em;
  word-break: break-word;
}

/* 作者信息区域 (照片 + 名称/职位) */
.author-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: auto;
  padding-top: 0.5rem;
  border-top: 1px solid #f0f2f5;
}

/* 照片圆形样式 */
.avatar-photo {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  background-color: #e2e8f0;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.author-details {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.author-name {
  font-weight: 700;
  font-size: 1.05rem;
  color: #0f172a;
  line-height: 1.3;
}

.author-title {
  font-size: 0.8rem;
  color: #5b6e8c;
  letter-spacing: 0.02em;
  font-weight: 450;
}
</style>